module.exports = __webpack_public_path__ + "static/media/createAreaKan.f28bc672.jpg";